import { GetAiLicensesRequest } from '@eggplant/api-requests'
import {
  createContext,
  useState
} from 'react'
import type {
  License,
  LicenseQuery
} from '@eggplant/types'
import type { ReactNode } from 'react'

interface RequirementsProps {
  isRequirementsEnabled?: boolean
}

export const RequirementsContext = createContext<RequirementsProps | undefined>(undefined)

interface ProviderProps {
  children: ReactNode
  isRequirementsEnabled?: boolean
}

export const RequirementsContextProvider = ({
  children,
  isRequirementsEnabled: isRequirementsEnabledProp
}: ProviderProps) => {
  const [isRequirementsEnabled, setIsRequirementsEnabled] = useState<boolean>(!!isRequirementsEnabledProp)

  const handleRequirementsSuccess = (licenseArray: License[]) => {
    setIsRequirementsEnabled(licenseArray.length > 0)
  }

  const handleRequirementsError = () => {
    setIsRequirementsEnabled(false)
  }

  const value = { isRequirementsEnabled }

  const params: LicenseQuery = {
    active: true,
    license_type: 'ReqT'
  }

  return (
    <GetAiLicensesRequest
      onError={handleRequirementsError}
      onSuccess={handleRequirementsSuccess}
      params={params}
    >
      {
        () =>
          <RequirementsContext.Provider value={value}>
            {children}
          </RequirementsContext.Provider>
      }
    </GetAiLicensesRequest>
  )
}

interface ConsumerProps {
  children: (context: RequirementsProps) => React.ReactNode
}

export const RequirementsContextConsumer = ({
  children: renderChildren
}: ConsumerProps) =>
  <RequirementsContext.Consumer>
    {
      (context?: RequirementsProps) => {
        if (context === undefined) {
          throw new Error('<RequirementsContextConsumer /> must be used within <RequirementsContextProvider />')
        }

        return renderChildren(context)
      }
    }
  </RequirementsContext.Consumer>
